<script lang="ts">
  import { CostsPeriod } from '../lib/costs-period';
  import { PeriodShortcuts } from '../lib/period-shortcuts';

  interface Props {
    applied: CostsPeriod;
    onApply: (period: CostsPeriod) => void;
  }

  let { applied, onApply }: Props = $props();

  const atalhos = new PeriodShortcuts().all();

  // Escolher a data já busca: não há o que revisar num par de datas, e o botão
  // extra custava um clique em toda troca de período. Data que deixaria o par
  // inválido não aplica, e os próprios campos já se limitam por `min`/`max`.
  function escolher(period: CostsPeriod): void {
    if (!period.isValid || period.equals(applied)) return;
    onApply(period);
  }
</script>

<div class="period">
  <div class="shortcuts">
    {#each atalhos as atalho (atalho.label)}
      <button
        class="shortcut"
        class:active={atalho.isApplied(applied)}
        onclick={() => escolher(atalho.period())}
      >
        {atalho.label}
      </button>
    {/each}
  </div>

  <div class="range">
    <button class="step" title="Período anterior" onclick={() => escolher(applied.previous())}>
      ‹
    </button>

    <label class="field">
      <span class="field-label mono">de</span>
      <input
        type="date"
        value={applied.from}
        max={applied.to}
        onchange={(e) => escolher(applied.withFrom(e.currentTarget.value))}
      />
    </label>
    <label class="field">
      <span class="field-label mono">até</span>
      <input
        type="date"
        value={applied.to}
        min={applied.from}
        onchange={(e) => escolher(applied.withTo(e.currentTarget.value))}
      />
    </label>

    <button
      class="step"
      title="Período seguinte"
      disabled={applied.endsToday}
      onclick={() => escolher(applied.next())}
    >
      ›
    </button>
  </div>

  <p class="summary">{applied.label} · {applied.days} dia{applied.days === 1 ? '' : 's'}</p>
</div>

<style>
  .period {
    display: flex;
    align-items: flex-end;
    gap: var(--space-3);
    flex-wrap: wrap;
  }
  .shortcuts {
    display: flex;
    gap: var(--space-1);
    margin-right: var(--space-2);
    flex-wrap: wrap;
  }
  .shortcut {
    background: none;
    border: 1px solid transparent;
    border-radius: var(--radius-sm);
    color: var(--text-tertiary);
    padding: var(--space-2) var(--space-3);
    font-size: 13px;
    cursor: pointer;
    transition: all var(--duration-fast) var(--easing-default);
  }
  .shortcut:hover {
    color: var(--text-primary);
    background: var(--bg-hover);
  }
  .shortcut.active {
    color: var(--text-primary);
    border-color: var(--color-success);
  }
  .range {
    display: flex;
    align-items: flex-end;
    gap: var(--space-2);
  }
  .step {
    background: var(--bg-elevated);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-sm);
    color: var(--text-primary);
    /* Alvo grande o bastante para acertar sem mirar. */
    padding: var(--space-2) var(--space-3);
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
  }
  .step:hover:not(:disabled) {
    background: var(--bg-hover);
  }
  .step:disabled {
    opacity: 0.35;
    cursor: default;
  }
  .shortcut:focus-visible,
  .step:focus-visible {
    outline: 2px solid var(--color-success);
    outline-offset: 2px;
  }
  .field {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
  }
  .field-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--text-tertiary);
  }
  .field input {
    background: var(--bg-elevated);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-sm);
    color: var(--text-primary);
    padding: var(--space-2) var(--space-3);
    font-size: 14px;
  }
  .field input:focus-visible {
    outline: 2px solid var(--color-success);
    outline-offset: 1px;
  }
  .summary {
    margin: 0 0 var(--space-2);
    color: var(--text-secondary);
    font-size: 14px;
  }
</style>
